import styled from 'styled-components';

import DriverList from './component';

export default styled(DriverList)`
  .driver-list {
    margin-bottom: 4rem;

    &__header {
      background-color: transparent;

      &:after {
        display: none;
      }

      .driver-list__header-row {
        background-color: transparent;

        &:hover {
          background-color: transparent;
        }
      }
    }

    &__row {
      color: var(--grey900);

      td {
        text-align: right;
      }

      &:hover {
        background-color: var(--primary100);

        .driver-list__phone-icon,
        .driver-list__cell-contact {
          opacity: 1;
        }
      }

      &--inactive {
        background-color: var(--grey100);

        .driver-list__cell-name,
        .driver-list__cell-type {
          opacity: 0.5;
        }
      }
    }

    &__header-row {
      td {
        text-align: right;
      }
    }

    &__cell-name {
      color: var(--grey700);
      font-weight: bold;
    }

    &__cell-type {
      font-weight: 500;
    }

    &__cell-jobs {
      color: var(--primary500);

      button {
        display: flex;
        justify-content: flex-end;
        padding: 0;
        width: 100%;

        .btnWrapper {
          display: flex;
          justify-content: flex-end;
        }
      }
    }

    &__phone-icon,
    &__cell-contact {
      opacity: 0;
    }
  }
`;
